import { createApp } from 'vue';
import WishlistPage from './wishlist-page.vue';
import commonStore from '../global/common-store';

export default () => {
  createApp(WishlistPage).use(commonStore).mount("vue-wishlist-page");
}